import { defineComponent as B, watch as f, ref as m, inject as g, openBlock as s, createElementBlock as i, normalizeClass as h, createElementVNode as e, normalizeStyle as L, toDisplayString as a, Fragment as _, renderList as y, createBlock as p, withCtx as d, createTextVNode as M, createCommentVNode as w, createVNode as N, renderSlot as $, withDirectives as T, unref as z, pushScopeId as A, popScopeId as E } from "vue";
import H from "../../assets/IST_LOGO.min.svg.mjs";
import R from "../icon/IstIcon.vue.mjs";
import j from "../dropdown/IstDropdown.vue.mjs";
import x from "../list/IstList.vue.mjs";
import F from "../list/IstItem.vue.mjs";
import q from "../../node_modules/v-wave/dist/es/index.mjs";
const r = (l) => (A("data-v-87fc1156"), l = l(), E(), l), G = { key: 0 }, J = {
  key: 1,
  class: "ist-header-section"
}, K = /* @__PURE__ */ r(() => /* @__PURE__ */ e("div", { class: "ist-header-section-logo" }, [
  /* @__PURE__ */ e("img", {
    alt: "logo",
    src: H
  })
], -1)), O = { class: "ist-header-section-start" }, P = { key: 0 }, Q = { class: "ist-breadcrumb tiny" }, U = ["onClick"], X = ["onClick"], Y = { key: 1 }, Z = /* @__PURE__ */ r(() => /* @__PURE__ */ e("span", {
  class: "divider",
  role: "presentation"
}, "/", -1)), ee = { class: "ist-header-section-end--shrink" }, te = { class: "ist-header-toolbar" }, se = { class: "ist-header-section-menu hoverable" }, oe = /* @__PURE__ */ r(() => /* @__PURE__ */ e("span", null, null, -1)), ie = /* @__PURE__ */ r(() => /* @__PURE__ */ e("span", null, null, -1)), le = /* @__PURE__ */ r(() => /* @__PURE__ */ e("span", null, null, -1)), re = [
  oe,
  ie,
  le
], pe = /* @__PURE__ */ B({
  __name: "IstMainHeader",
  props: {
    title: { default: "Title missing" },
    titleWithCrumbs: { default: null },
    mobile: { type: Boolean }
  },
  emits: ["breadCrumbsClicked"],
  setup(l, { emit: I }) {
    const { vWave: W } = q.createLocalWaveDirective(), S = I, v = l, b = (o) => {
      S("breadCrumbsClicked", o);
    };
    f(
      () => v.mobile,
      (o) => {
        u.value = o;
      }
    );
    const D = m(!1), C = g("mobile", v.mobile), u = m(C), V = g("showMenu", !0), c = m(V);
    return f(
      () => C,
      (o) => {
        u.value = o;
      }
    ), (o, k) => (s(), i("header", {
      class: h(["ist-header", { mobile: u.value }])
    }, [
      D.value ? (s(), i("div", G)) : (s(), i("div", J, [
        K,
        e("div", O, [
          e("ul", null, [
            e("li", null, [
              e("h1", {
                "data-test": "header-title",
                class: "ist-header-title",
                style: L({
                  lineHeight: o.titleWithCrumbs ? "initial !important" : ""
                })
              }, a(o.title), 5)
            ]),
            o.titleWithCrumbs ? (s(), i("li", P, [
              e("div", Q, [
                (s(!0), i(_, null, y(o.titleWithCrumbs.breadCrumbs, (t) => (s(), i(_, {
                  key: t.title
                }, [
                  e("div", {
                    class: h(["section hoverable", {
                      clickable: t.route && t.route.length > 0 || t.breadCrumbs && t.breadCrumbs.length > 0
                    }]),
                    onClick: (n) => b(t.route)
                  }, [
                    t.breadCrumbs && t.breadCrumbs.length > 0 ? (s(), p(j, { key: 0 }, {
                      trigger: d(() => [
                        M(a(t.title) + " ", 1),
                        t.breadCrumbs && t.breadCrumbs.length > 0 ? (s(), p(R, {
                          key: 0,
                          name: "r_arrow_drop_down",
                          role: "presentation"
                        })) : w("", !0)
                      ]),
                      default: d(() => [
                        N(x, {
                          dense: "",
                          style: { "min-width": "100px" }
                        }, {
                          default: d(() => [
                            (s(!0), i(_, null, y(t.breadCrumbs, (n) => (s(), p(F, {
                              key: n.title,
                              clickable: ""
                            }, {
                              default: d(() => [
                                e("div", {
                                  class: "clickable",
                                  onClick: (ne) => b(n.route)
                                }, a(n.title), 9, X)
                              ]),
                              _: 2
                            }, 1024))), 128))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)) : (s(), i("div", Y, a(t.title), 1))
                  ], 10, U),
                  Z
                ], 64))), 128))
              ])
            ])) : w("", !0)
          ])
        ]),
        e("div", ee, [
          e("div", te, [
            $(o.$slots, "headertoolbar", {}, void 0, !0)
          ])
        ]),
        T((s(), i("div", se, [
          e("div", {
            class: h(["navigation-menu-icon", { expanded: c.value }]),
            onClick: k[0] || (k[0] = (t) => c.value = !c.value)
          }, re, 2)
        ])), [
          [z(W)]
        ])
      ]))
    ], 2));
  }
});
export {
  pe as default
};
